import { gql } from "@apollo/client";

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  PREFER_TO_NOT_ANSWER = "PREFER_TO_NOT_ANSWER"
}

export const ADD_PATIENT_INFORMATION = gql`
  mutation addPatientInformation(
    $patientId: Int!
    $professionistId: Int!
    $name: String!
    $surname: String!
    $codFisc: String!
    $address: String!
    $cap: String!
    $birthDate: Date!,
    $birthPlace: String!,
    $city: String!
    $province: String!
    $gender: Gender
    $nation: String!
    $phone: String
  ) {
    consensoInformato(
      patient_id: $patientId
      professionist_id: $professionistId
      name: $name
      surname: $surname
      address: $address
      city: $city,
      birth_date: $birthDate,
      birth_place: $birthPlace,
      province: $province,
      phone: $phone,
      cod_fisc: $codFisc,
      cap: $cap
      gender: $gender
      nation: $nation
    ) {
      id
    }
  }
`;

export const GET_REGION_OPTIONS = gql`
  query getRegionOptions {
    provinces {
      name
      code 
    }
  }
`;
